import type { BomMaterial } from '../../gql';

import { randBoolean, randNumber, randSentence } from '@ngneat/falso';

import { mockMaterial } from './mockMaterial';
import { mockMaterialOnTheFly } from './mockMaterialOnTheFly';
import { mockStyleOptionColourLink } from './mockStyleOptionColourLink';
import { mockUnitOfMeasurement } from './mockUnitOfMeasurement';

const mockBomMaterial = (override?: Partial<BomMaterial>): BomMaterial => {
    const hasMaterialOnTheFly = randBoolean();
    return {
        material: hasMaterialOnTheFly ? undefined : mockMaterial(),
        avgConsumption: randBoolean() ? randNumber() : null,
        unitOfMeasurement: randBoolean() ? mockUnitOfMeasurement() : null,
        comment: randBoolean() ? randSentence() : undefined,
        size: randBoolean()
            ? `W${randNumber()}mm x L${randNumber()}mm x T${randNumber()}mm`
            : undefined,
        materialOnTheFly: hasMaterialOnTheFly
            ? mockMaterialOnTheFly()
            : undefined,
        styleOptionColourLinks: Array.from(
            { length: randNumber({ min: 1, max: 3 }) },
            () => mockStyleOptionColourLink()
        ),
        ...override,
    };
};

export { mockBomMaterial };
